import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { SharedComponentsModule } from '../../../../../shared/components/shared-components.module';
import { ValidationResultsModule } from '../../../../../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../../../../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../../../../../shared/pipes/shared-pipes.module';
import { SharedValidatorsModule } from '../../../../../shared/validators/shared-validators.module';
import { VehicleOwnershipDeInsuranceModalComponent } from './vehicle-ownership-de-insurance-modal.component';

@NgModule({
    declarations: [
        VehicleOwnershipDeInsuranceModalComponent
    ],
    imports: [
        CalendarModule,
        CommonModule,
        FileUploadModule,
        ReactiveFormsModule,
        MVMSpinnerBtnModule,
        SharedComponentsModule,
        SharedPipesModule,
        SharedValidatorsModule,
        ValidationResultsModule
    ]
})
export class VehicleOwnershipDeInsuranceModalModule {
}
